import React , { useRef, useState, useEffect  } from "react";
import "./Contact.css";
import {RiSendPlaneFill} from "react-icons/ri";
import Fade from 'react-reveal/Fade';
import emailjs from '@emailjs/browser';


//dotenv.config(); // No need to specify a path if it's in the root folder

const Contact = () => {
  const formRef = useRef();
  const [done, setDone] = useState(false);
  const [name, setName] = useState('');
  const [subject, setSubject] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const nameChangeHandler = (e) => {
    setName(e.target.value);
  };

  const subjectChangeHandler = (e) => {
    setSubject(e.target.value);
  };

  const emailChangeHandler = (e) => {
    setEmail(e.target.value);
  };

  const messageChangeHandler = (e) => {
    setMessage(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

  
    alert('Message has been sent');
    emailjs.sendForm(
      "service_1fgpsrl",
       "template_tvcp36a", 
       formRef.current, 
       "Hldd_dkGXnqkq9yaI")
      .then((result) => {
          console.log(result.text);
          setDone(true);
          console.log("message sent")
      }, (error) => {
          console.log(error.text);
      });
  };

  useEffect(() => {
    if (done) {
      setName('');
      setSubject('');
      setEmail('');
      setMessage('');


    } else {
      setName('');
      setSubject('');
      setEmail('');
      setMessage('');
    }
  }, [done]);


  return (
    <div className="container contact-section" id="contactsection">
    <div className="row">
      <Fade bottom>
        <div className="col-xl-5 col-lg-5 col-md-5 col-sm-5 ">
          <div className="contact-form-image">
            <img
              src="https://images.pexels.com/photos/7793193/pexels-photo-7793193.jpeg"
              alt="contact-form"
            />
          </div>
        </div>
      </Fade>

      <Fade right>
        <div className="col-xl-7 col-lg-7 col-md-7 col-sm-7 ">
          <div className="contact-form-design">
            <div className="text-center">
              <h5>Contact Me</h5>
            </div>
            <form ref={formRef} onSubmit={handleSubmit}>
              <div className="contact-form">
                <label className="form-label">Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={name}
                  onChange={nameChangeHandler}
                  name="user_name" 
                />
              </div>
              <div className="contact-form">
                <label className="form-label">E-mail</label>
                <input
                  type="text"
                  className="form-control"
                  value={email}
                  onChange={emailChangeHandler}
                  name="user_email" 
                />
              </div>
              <div className="contact-form">
                <label className="form-label">Job Types</label>
                <select
                  className="custom-select"
                  name="job_type"
                  value={subject} 
                  onChange={subjectChangeHandler} 
                >
                  <option>--Select-a-Option--</option>
                  <option>Full Time</option>
                  <option>Part-Time</option>
                  <option>Contract</option>
                  <option>Working Student</option>
                </select>
              </div>
              <div className="contact-form">
                <label className="form-label">Message</label>
                <textarea
                  rows="5"
                  type="text"
                  className="form-control"
                  value={message}
                  onChange={messageChangeHandler}
                  name="message" 
                />
              </div>
              <button type="submit" className="button-submit">
                <p>
                  SEND <RiSendPlaneFill size={20} />
                </p>
              </button>
            </form>
          </div>
        </div>
      </Fade>
    </div>
  </div>
);
};

export default Contact;